import type { RouterPathFunction } from './utils';

export default <P = void>(fn: RouterPathFunction<P>, parameter: keyof P) => {
    fn.raw = fn.raw.replace(parameter as string, `${String(parameter)}?`);

    return fn;
};
